<template>
  <template-product-card></template-product-card>
</template>

<script lang="ts">

import templateProductCard from '@/app-template/lib/components/ProductCard.vue';

export default {
  components: { templateProductCard },
};
</script>